const wrapperCls = "_vcw24pg3i";

export { wrapperCls };
import "./ErrorMessage.linaria.module.css";
//# sourceMappingURL=ErrorMessage.js.map
